(function () {
  'use strict';

  var COOKIE_SELECTOR = '[data-fd-cookie]';
  var STICKY_SELECTOR = '.fd-pdp .fd-pdp-sticky';
  var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 768px)') : { matches: true };
  var scheduled = false;
  var canonicalCookie = null;
  var observedCookie = null;
  var sizeObserver = window.ResizeObserver ? new ResizeObserver(scheduleSync) : null;
  var attributeObserver = window.MutationObserver ? new MutationObserver(scheduleSync) : null;

  function setAttributeIfChanged(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function hideDuplicate(cookie) {
    setAttributeIfChanged(cookie, 'data-fd-overlay-duplicate', 'true');
    setAttributeIfChanged(cookie, 'aria-hidden', 'true');
    if (!cookie.hidden) cookie.hidden = true;
    if (cookie.style.getPropertyValue('display') !== 'none' || cookie.style.getPropertyPriority('display') !== 'important') {
      cookie.style.setProperty('display', 'none', 'important');
    }
  }

  function chooseCanonicalCookie() {
    var cookies = Array.prototype.slice.call(document.querySelectorAll(COOKIE_SELECTOR));
    if (!cookies.length) {
      canonicalCookie = null;
      return null;
    }

    if (!canonicalCookie || cookies.indexOf(canonicalCookie) === -1) {
      canonicalCookie = cookies.filter(function (cookie) {
        return !!cookie.closest('footer, .site-footer, [data-section-type*="footer"], [data-section-id*="footer"]');
      }).pop() || cookies[cookies.length - 1];
    }

    cookies.forEach(function (cookie) {
      if (cookie !== canonicalCookie) hideDuplicate(cookie);
    });

    if (canonicalCookie.getAttribute('data-fd-overlay-duplicate') === 'true') {
      canonicalCookie.removeAttribute('data-fd-overlay-duplicate');
      if (canonicalCookie.getAttribute('aria-hidden') === 'true') canonicalCookie.removeAttribute('aria-hidden');
    }
    setAttributeIfChanged(canonicalCookie, 'data-fd-overlay-canonical', 'true');

    if (sizeObserver) {
      if (!mobileQuery.matches && observedCookie) {
        sizeObserver.unobserve(observedCookie);
        observedCookie = null;
      } else if (mobileQuery.matches && observedCookie !== canonicalCookie) {
        if (observedCookie) sizeObserver.unobserve(observedCookie);
        sizeObserver.observe(canonicalCookie);
        observedCookie = canonicalCookie;
      }
    }
    return canonicalCookie;
  }

  function getVisibleRect(element) {
    if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return null;
    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return null;
    var rect = element.getBoundingClientRect();
    return rect.width > 1 && rect.height > 1 && rect.bottom > 0 && rect.top < window.innerHeight ? rect : null;
  }

  function syncOverlayState() {
    scheduled = false;
    if (!document.body) return;

    var cookie = chooseCanonicalCookie();
    if (!mobileQuery.matches) {
      document.body.classList.remove('fd-overlay-cookie-visible', 'fd-overlay-sticky-visible');
      document.body.classList.add('fd-overlay-controller-ready');
      if (document.documentElement.style.getPropertyValue('--fd-cookie-overlay-height')) {
        document.documentElement.style.removeProperty('--fd-cookie-overlay-height');
      }
      return;
    }

    var cookieRect = getVisibleRect(cookie);
    var cookieVisible = !!cookieRect;
    var stickyVisible = !cookieVisible && Array.prototype.some.call(
      document.querySelectorAll(STICKY_SELECTOR),
      getVisibleRect
    );

    document.body.classList.toggle('fd-overlay-cookie-visible', cookieVisible);
    document.body.classList.toggle('fd-overlay-sticky-visible', stickyVisible);
    document.body.classList.add('fd-overlay-controller-ready');

    var cookieHeight = cookieRect ? Math.ceil(cookieRect.height) : 0;
    var heightValue = cookieHeight + 'px';
    if (document.documentElement.style.getPropertyValue('--fd-cookie-overlay-height') !== heightValue) {
      document.documentElement.style.setProperty('--fd-cookie-overlay-height', heightValue);
    }
  }

  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(syncOverlayState);
  }

  function observeOverlayTargets() {
    if (!attributeObserver) return;
    if (!mobileQuery.matches) {
      attributeObserver.disconnect();
      return;
    }
    document.querySelectorAll(COOKIE_SELECTOR + ', ' + STICKY_SELECTOR).forEach(function (element) {
      attributeObserver.observe(element, {
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
      });
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;
    if (target.closest('[data-fd-cookie-close], .fd-pdp-sticky, [data-fd-add-to-cart]')) {
      window.setTimeout(scheduleSync, 0);
      window.setTimeout(scheduleSync, 180);
    }
  }, true);

  function handleViewportChange() {
    observeOverlayTargets();
    scheduleSync();
  }

  window.addEventListener('resize', handleViewportChange, { passive: true });
  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', handleViewportChange);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(handleViewportChange);
  }
  window.addEventListener('pageshow', scheduleSync);
  window.addEventListener('load', function () {
    observeOverlayTargets();
    scheduleSync();
  });
  document.addEventListener('shopify:section:load', function () {
    observeOverlayTargets();
    scheduleSync();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observeOverlayTargets();
      scheduleSync();
    }, { once: true });
  } else {
    observeOverlayTargets();
    scheduleSync();
  }

  [320, 1250, 3200].forEach(function (delay) {
    window.setTimeout(scheduleSync, delay);
  });
})();
